import request from '../utils/request';
import { APIHOST } from '../config';

export async function fetchEnabledBetaFeatures(payload) {
  const { id } = payload;
  return request('GET', `${APIHOST}/beta_feature/Company/${id}/setting`);
}
